module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/nervousness/2bdd51db2651c9ee34242289ba5b9a41.png";